export const setError = (state, payload) => {
  if (state && payload) {
    state.status.error = payload
    state.status.success = null
    state.status.processing = false
    // if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
    // }
  }
}

export const clearError = (state) => {
  if (state) {
    state.status.error = null
    state.status.success = null
    state.status.processing = false
    // if (objectBulkCheckProps(state, ['error'])) {
    // }
  }
}

export const setSuccess = (state, payload) => {
  if (state) {
    state.status.error = null
    state.status.success = payload
    state.status.processing = false
    // if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
    // }
  }
}

export const setProcessing = (state, payload) => {
  if (state) {
    state.status.processing = payload
    // if (objectBulkCheckProps(state, ['error', 'success', 'processing'])) {
    // }
  }
}

/*function objectBulkCheckProps (object, propList) {
  if (object && Array.isArray(propList)) {
    if (propList.length > 0) {
      const result = propList
        .every(prop => Object.prototype.hasOwnProperty.call(object, prop))
      console.log(result);
      return result
    }
  }
  return null
}*/
